
let isScrolling;

// listen for scroll events
window.addEventListener("scroll", function(event){
    // clear out timeout throught the scroll
    window.clearTimeout(isScrolling);
    
    // set a timeout to run after scrolling ends
    isScrolling = setTimeout(function(){
        // run the callback function
        document.querySelector('body').classList.remove('no-hover');
    }, 40);

    // immediately and 'no-hover' class to body on scroll
    document.querySelector('body').classList.add('no-hover');

}, false)

